import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface teacher{
    name:string,
    id:string,
    pw:string,
    tel:string,
    email:string,
    address:string,
    address_detail:string
}

const useAccountInfo = (teacher_id:string) => {
    const {getBranchId} = useGetBranchId();
    const {readFirestoreOneDoc, readFirestoreWithQuery} = useFirestore();
    const [lessonName, setLessonName] = useState<string>("");
    const [studentCount, setStudentCount] = useState<number>(0);
    const [teacher, setTeacher] = useState<teacher>({
        name:"",
        id:"",
        pw:"",
        tel:"",
        email:"",
        address:"",
        address_detail:""
    });

    useEffect(() => {
        if(teacher_id){
            getData();
            getStudentCount();
        }
        // eslint-disable-next-line
    }, [teacher_id])


    const onRefreshClick = () => {
        getData();
    }

    const getData = async() => {
        const data = await readFirestoreOneDoc("User/Auth/Teacher", teacher_id).then(res => {
            if(res.exists()){
                return res.data();
            }else{
                return null;
            }
        })

        if(data){
            setTeacher({
                name:data.name,
                id:data.id,
                pw:data.pw,
                tel:data.tel,
                email:data.email,
                address:data.address,
                address_detail:data.address_detail
            });
        }
    }

    const getStudentCount = async() => {
        const branch_id = await getBranchId();
        const lesson =  await readFirestoreWithQuery(`Lesson/Branch/${branch_id}`, {field:"teacher", operator:"==", data:teacher_id}).then(res => {
            if(!res.empty){
                const doc = res.docs[0];
                return {lesson_id:doc.id, lesson_name:doc.data().name}
            }
        })
        if(lesson && lesson.lesson_id){
            const count = await readFirestoreOneDoc(`Assign/${branch_id}/Lesson`, lesson.lesson_id).then(res => {
                if(res.exists()){
                    return res.data().students.length;
                }
                return 0;
            })
            setStudentCount(count);
            setLessonName(lesson.lesson_name);
        }
    }

    return {teacher, onRefreshClick, studentCount, lessonName};
}

export default useAccountInfo;